export const BackToTopIcon = (props: React.HTMLAttributes<SVGElement>) => {
  const { className, ...rest } = props;

  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0001 3.45217L8.72575 0.123291L5.45135 3.45217H8.13727V8.67125C8.13727 9.80612 7.21727 10.7261 6.0824 10.7261H0V11.8768H6.0824C7.8528 11.8768 9.28799 10.4417 9.28799 8.67125V3.45217H12.0001Z'
        fill='white'
      />
    </svg>
  );
};
